import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { calculateCompoundInterest } from './utils/compoundInterest'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const formatBRL = (value) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const CompoundInterestCalculator = () => {
  useDocumentMeta({
    title: 'Calculadora de Juros Compostos Online  jarder.dev',
    description:
      'Simule o crescimento de um investimento com aportes mensais e ' +
      'juros compostos. Grátis, direto no navegador.',
  })

  const [principal, setPrincipal] = useState('1000')
  const [contribution, setContribution] = useState('200')
  const [rate, setRate] = useState('0.8')
  const [months, setMonths] = useState('60')

  const result = useMemo(() => {
    const p = parseFloat(principal.replace(',', '.')) || 0
    const c = parseFloat(contribution.replace(',', '.')) || 0
    const r = (parseFloat(rate.replace(',', '.')) || 0) / 100
    const m = Math.max(0, Number.parseInt(months, 10) || 0)
    return calculateCompoundInterest({
      principal: p,
      monthlyContribution: c,
      monthlyRate: r,
      months: m,
    })
  }, [principal, contribution, rate, months])

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Calculadora de Juros Compostos</h1>
      <p className="tool-disclaimer">
        Simulação estimada  não considera impostos, taxas ou inflação.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="principal">Valor inicial (R$)</label>
          <input
            id="principal"
            type="text"
            inputMode="decimal"
            value={principal}
            onChange={(e) => {
              setPrincipal(e.target.value)
              trackEvent('tool_generate', { tool: 'compound_interest' })
            }}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="contribution">Aporte mensal (R$)</label>
          <input
            id="contribution"
            type="text"
            inputMode="decimal"
            value={contribution}
            onChange={(e) => setContribution(e.target.value)}
          />
        </div>
      </div>
      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="rate">Juros ao mês (%)</label>
          <input
            id="rate"
            type="text"
            inputMode="decimal"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="months">Período (meses)</label>
          <input
            id="months"
            type="number"
            min="1"
            value={months}
            onChange={(e) => setMonths(e.target.value)}
          />
        </div>
      </div>

      <div className="tool-result-card">
        <span className="tool-result-label">Valor final</span>
        <span className="tool-result-value">
          {formatBRL(result.finalBalance)}
        </span>
      </div>
      <div className="tool-row">
        <div className="tool-result-card">
          <span className="tool-result-label">Total investido</span>
          <span className="tool-result-value">
            {formatBRL(result.totalInvested)}
          </span>
        </div>
        <div className="tool-result-card">
          <span className="tool-result-label">Total em juros</span>
          <span className="tool-result-value">
            {formatBRL(result.totalInterest)}
          </span>
        </div>
      </div>

      <div className="tool-info-section">
        <h2>Como o cálculo é feito</h2>
        <p>
          A cada mês, o saldo acumulado rende os juros informados e
          recebe o aporte mensal, e no mês seguinte os juros incidem
          sobre esse novo total  é esse efeito "juros sobre juros" que
          faz o valor final crescer de forma acelerada, não linear.
          Pequenas diferenças na taxa mensal ou no prazo fazem bastante
          diferença no resultado a longo prazo.
        </p>
      </div>
    </div>
  )
}

export default CompoundInterestCalculator
